import React, { useEffect, useState } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import GroupUserTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
  ImageCell,
  ProductCell,
} from "./GroupUserTable"; // new
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsGroupUserdata } from "../../../../redux/slices/statistics/statisticSlice";
import { SetCurrentID } from "../../../../redux/slices/item/itemSlice";
function GroupUserData(ID) {
  const [Data, setData] = useState();
  const CurrentID = useSelector((state) => state.item.CurrentID);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);
  const APIDetailsGroupUserdata = useSelector(
    (state) => state.statistics.APIDetailsGroupUserdata
  );
  const dispatch = useDispatch();

  const getGroupuserData = () => {
    getAuthorization()
      .get(`company/group_staff/${ID.id.id.group?.id}/`)
      .then((res) => {
        setData(res.data.staff);
        dispatch(setAPIDetailsGroupUserdata(res.data.staff));
        console.log("res.data", res.data.staff);
        dispatch(SetCurrentID(ID.id.id.id));


      })
      .catch((err) => {
        console.log("Error in getting schedule", err);
      });
  };

  useEffect(() => {
    if (
      APIDetailsGroupUserdata === null ||
      CurrentID !== ItemDetails.id
    ) {
      getGroupuserData();
      console.log("Api called", ID);
      console.log("ID.id....", ID.id.id.id);

      console.log("Useeffect called...group user", APIDetailsGroupUserdata);
    }
    console.log("APIDetailsGroupUserdata.....", APIDetailsGroupUserdata);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        Cell: AvatarCell,
      },
      {
        Header: "Job Role",
        accessor: "job_role",
      },
      {
        Header: "Actions",
        accessor: "action",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 font-medium ">
              {" "}
              <button className="float-right mt-3">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                    fill="#1F78B4"
                  />
                </svg>
              </button>
            </div>
            <div className=" ml-4 text-gray-400 font-medium">
              <button className="float-right mt-3">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_663_5557)">
                    <path
                      d="M9.53671 2.82133L0.974129 11.2473L0 16L4.82797 15.0413L13.3912 6.61467L9.53671 2.82133ZM2.51255 12.75L1.93674 12.1833L9.48387 4.76667L10.059 5.33267L2.51255 12.75ZM3.87281 14.0887L3.297 13.522L10.8441 6.10533L11.4199 6.672L3.87281 14.0887ZM16.2581 3.79267L14.3505 5.67133L10.4953 1.87733L12.4029 0L16.2581 3.79267Z"
                      fill="#1F78B4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_663_5557">
                      <rect width="16.2581" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <GroupUserTable
            columns={columns}
            data={
              APIDetailsGroupUserdata === null
                ? []
                : APIDetailsGroupUserdata
            }
            text="Upcoming Deliveries"
          />
        </div>
      </main>
    </div>
  );
}

export default GroupUserData;
